// ============================================================
// useDebounce Hook
// ============================================================

import { useEffect, useState } from 'react';
import { DEBOUNCE_DELAY } from '@/constants/app';

export function useDebounce(value, delay = DEBOUNCE_DELAY) {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebouncedValue(value), delay);
    return () => clearTimeout(timer);
  }, [value, delay]);

  return debouncedValue;
}
